import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { mergeMap, Observable, of } from "rxjs";
import { PurposeEnum } from "src/app/models/shared-models";
import {FeatureFlags, FeatureFlagService } from "src/app/services/feature-flag.service";
import { environment } from "src/environments/environment";
import { IActivityDataModel, IGeneralInformationModel, ICategoryPurposeActivityDataModel, ISetActivitiesResponseModel, IPurposeModel } from "../models/veg-wizard-models";
import { Logger } from "./logger-service";

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  constructor(protected http: HttpClient,
    private logger: Logger,
    private featureFlagService: FeatureFlagService) {
  }

  getActivitiesForCategoryAndPurpose$(categoryCodes: string[], purposeCode: string): Observable<ICategoryPurposeActivityDataModel[]> {
    const url = `${environment.apiUrl}/session/activities-for-category-and-purpose?categoryCodes=${encodeURIComponent(categoryCodes.join(','))}&purposeCode=${encodeURIComponent(purposeCode)}`;

    return this.http.get<ICategoryPurposeActivityDataModel[]>(url)
      .pipe(mergeMap(result => {
        return of(result);
      }));
  }

  setActivities$(model: IActivityDataModel[], sessionId: string | undefined): Observable<ISetActivitiesResponseModel> {

    return this.http.post<ISetActivitiesResponseModel>(
      `${environment.apiUrl}/session/set-activities`, { Activities: model, SessionKey: sessionId });

  }

  getActivityMessage(purpose: IPurposeModel | undefined): IGeneralInformationModel {
    const activityQuestionaire: IGeneralInformationModel | null = {} as IGeneralInformationModel;

    if (purpose && (purpose.purposeCode == PurposeEnum.certifiedNativeForestPractice ||
      (this.featureFlagService.featureEnabled(FeatureFlags.NFP2019) && purpose.purposeCode == PurposeEnum.nativeForestPractice))) {
      activityQuestionaire.promptQuestionMessage = 'Will the clearing under this notification be part of an ongoing forestry business?';
      activityQuestionaire.userSelectsNoDisplayMessage = 'Clearing for this activity must be part of an ongoing forestry business.';
    }

    return activityQuestionaire;
  }
}
